<template>
  <div class="container-page">
    <IntroTitle
      title="Cafe Movistar"
      path="Inicio"
      padding="10px 30px"
      paddingDesktop="10px 50px"
      titleFontSize="1.6rem"
      titleMobileFontSize="1.3rem"
      descriptionAlign="initial"
      descriptionMobileAlign="center"
      transform="uppercase"
      page="Home"
      effect="top-to-bottom--effect"
      :boostrap="true">
    </IntroTitle>
    <div class="pdf">
      <vue-pdf-embed ref="pdfRef" :source="pdfSrc" />
    </div>
  </div>
</template>

<script setup>
  import VuePdfEmbed from 'vue-pdf-embed'
  import 'vue-pdf-embed/dist/styles/annotationLayer.css'
  import 'vue-pdf-embed/dist/styles/textLayer.css'
  import { useI18n } from 'vue-i18n';
  import IntroTitle from '@/components/movistar/common/IntroTitle.vue'
  import { onBeforeMount, ref } from 'vue';

  const pdfSrc = ref('')
  const { locale } = useI18n()

  onBeforeMount(() => {
    pdfSrc.value = `pdf/menu_movistar_${locale.value}_light_rev02.pdf`
  })
</script>

<style lang="scss" scoped>
  @import '@/scss/mixings';


  .pdf{
    display: grid;
    width: 100%;
    grid-template-columns: repeat(1, 1fr); 
    @media screen and (min-width: $md-breakpoint) {
      grid-template-columns: repeat(1, 1fr); 
    }
  }

  .iframe-menu {
    @include d-flex(row, space-between, initial);
    height: 100%;
    #timeToEat {
      width: 100dvw;
      border: 0;
    }
  }
</style>
